import api from './api';

export function getByUser(userId, params) {
    return api.get(`/users/${userId}/audit-logs`, { params });
}